module.exports = __webpack_public_path__ + "img/xlsx.09008028.svg";